import primaryComponents from "../../../../primaryComponents";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { WaybillImage } from "../../../../../assets/svgImages";
import { EyeIcon, WaybillIcon } from "../../../../../assets/svgIcons";

export const AdditionalDetailsForm = ({
  gRForm,
  setGRForm = () => {},
  handleUploadWaybill = () => {},
  ...validationParams
}) => {
  const { register, control } = validationParams;

  return (
    <div className={`${globalStyles.cardWithBorder} white`}>
      <h4 className="mb-4 font-weight-normal">Additional Details</h4>

      <div className={"d-flex flex-column flex-md-row"} style={{ gap: "15px" }}>
        <div className={`w-100 ${globalStyles.cardWithBorder}`}>
          <primaryComponents.InputFieldV2
            control={control}
            name={"waybill_no"}
            register={register}
            label="Waybill No"
            placeHolder={"Enter waybill number"}
            className={"white"}
            value={gRForm?.waybill_no}
            onChange={({ target: { value } }) => {
              setGRForm((prev) => ({
                ...prev,
                waybill_no: value,
              }));
            }}
          />
          <primaryComponents.InputFieldV2
            control={control}
            name={"waybill_driver_name"}
            register={register}
            label="Driver's Name"
            placeHolder={"Enter driver's name"}
            className={"white"}
            value={gRForm?.waybill_driver_name}
            onChange={({ target: { value } }) => {
              setGRForm((prev) => ({
                ...prev,
                waybill_driver_name: value,
              }));
            }}
          />

          <primaryComponents.PhoneNumberInputFieldV2
            control={control}
            name={"waybill_driver_phone_number"}
            register={register}
            label="Driver's Phone Number"
            placeHolder={"Enter driver's phone number"}
            classNames={"white"}
            value={gRForm?.waybill_driver_phone_number}
            onChange={({ target: { value } }) => {
              setGRForm((prev) => ({
                ...prev,
                waybill_driver_phone_number: value,
              }));
            }}
          />
          <primaryComponents.TextArea
            control={control}
            name={"notes"}
            register={register}
            label="Comments or Special Instruction"
            value={gRForm?.notes}
            onChange={({ target: { value } }) => {
              setGRForm((prev) => ({
                ...prev,
                notes: value,
              }));
            }}
          />
        </div>

        <div className={`w-100 ${globalStyles.cardWithBorder} card-plain px-0`}>
          <div className="d-flex justify-content-between px-3">
            <div>
              <h6 className="mb-0">Waybill</h6>
              <p className="gray--text small-text-size">Upload image here</p>
            </div>

            <div>
              <primaryComponents.FileInput
                name="waybillReceipt"
                placeHolder={"Upload File"}
                coverStyle={{ width: "170px" }}
                floatError={false}
                truncateTextSize={15}
                onChange={(document, fileName) => {
                  handleUploadWaybill(document, fileName);
                }}
              />
            </div>
          </div>

          {!gRForm?.waybill_url ? (
            <>
              <hr />
              <div className="text-center mt-3 px-3">
                <WaybillImage />
                <p>
                  No file uploaded
                  <br />
                  File uploaded will appear here
                </p>
              </div>
            </>
          ) : (
            <div
              className={`${globalStyles.cardWithBorder} flex-row align-items-center justify-content-between white px-3`}
              style={{
                borderRadius: 0,
                borderRight: "none",
                borderLeft: "none",
              }}
            >
              <span className="d-flex align-items-center">
                <WaybillIcon className="mr-2" />
                {gRForm?.file_name}
              </span>

              <span
                className="cursor-pointer d-flex align-items-center"
                onClick={() => window.open(gRForm?.waybill_url)}
              >
                <EyeIcon />
                <span className="purple--text small-text-size ml-2">
                  View File
                </span>
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
